// extracted by mini-css-extract-plugin
export default {"zoomModal":"E2-z","image":"F2-z","button":"G2-z","isOverlayShown":"H2-z"};